export class CmsCanvas {
    constructor(private readonly root: HTMLElement) {}

    notifyUpdated(): void {
        this.root.dispatchEvent(new CustomEvent("cms:canvas-updated", { bubbles: true }));
    }
}
